export default __webpack_public_path__ + "static/media/inactiveBranded.a3b5debb.svg";